

export const Boxing = [
    {
    "id": 21,
    "Title": "IES-2024-21",
    "ImageSource": "/Boxing/BoxingGloves/21.jpeg",
    "Category": "Bag Gloves"
},
{
    "id": 22,
    "Title": "IES-2024-22",
    "ImageSource": "/Boxing/BoxingGloves/22.jpeg",
    "Category": "Bag Gloves"
},
{
    "id": 23,
    "Title": "IES-2024-23",
    "ImageSource": "/Boxing/BoxingGloves/23.jpeg",
    "Category": "Bag Gloves"
},
{
    "id": 24,
    "Title": "IES-2024-24",
    "ImageSource": "/Boxing/BoxingGloves/24.jpeg",
    "Category": "Bag Gloves"
},
{
    "id": 25,
    "Title": "IES-2024-25",
    "ImageSource": "/Boxing/BoxingGloves/25.jpeg",
    "Category": "Bag Gloves"
},
{
    "id": 26,
    "Title": "IES-2024-26",
    "ImageSource": "/Boxing/BoxingGloves/26.jpeg",
    "Category": "Bag Gloves"
},
{
    "id": 27,
    "Title": "IES-2024-27",
    "ImageSource": "/Boxing/BoxingGloves/27.jpeg",
    "Category": "Bag Gloves"
},
];